// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._19bvze3t{padding-left:var(--ds-space-0,0)}
._1bsb1tcg{width:24px}
._4t3i1tcg{height:24px}
._bfhk1j28{background-color:transparent}
._ca0qze3t{padding-top:var(--ds-space-0,0)}
._n3tdze3t{padding-bottom:var(--ds-space-0,0)}
._tzy4idpf{opacity:0}
._u5f3ze3t{padding-right:var(--ds-space-0,0)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/rovo-agent-components/dist/esm/common/ui/star-icon-button/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,gCAAgC;AAC3C,WAAW,UAAU;AACrB,WAAW,WAAW;AACtB,WAAW,4BAA4B;AACvC,WAAW,+BAA+B;AAC1C,WAAW,kCAAkC;AAC7C,WAAW,SAAS;AACpB,WAAW,iCAAiC","sourcesContent":["._19bvze3t{padding-left:var(--ds-space-0,0)}\n._1bsb1tcg{width:24px}\n._4t3i1tcg{height:24px}\n._bfhk1j28{background-color:transparent}\n._ca0qze3t{padding-top:var(--ds-space-0,0)}\n._n3tdze3t{padding-bottom:var(--ds-space-0,0)}\n._tzy4idpf{opacity:0}\n._u5f3ze3t{padding-right:var(--ds-space-0,0)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
